export class OrderData {
    code: number;

    constructor(orderData?: any) {
        if(orderData) {
            this.code = orderData.code;
        }
    }
}
